import hdrm from '../../hdrm';
import site from '../../site';

import actionTypes from '../constants/action-types';
import { UPDATE_LIVE_ONLY } from '../../hdrm/constants/update-strategies';

const handleUpdateAtomicCSSAction = (action) => {
  const { stylesString, options } = action.payload;
  const { strategy } = options;

  return hdrm.operations.updateAtomicCss(stylesString, strategy);
};

const updateAtomicCSS = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.BULK_VIEW_ACTIONS: {
      const actions = action.payload.actions.filter(
        (targetAction) => targetAction.type === actionTypes.UPDATE_ATOMIC_CSS
      );

      actions.forEach((targetAction) => {
        handleUpdateAtomicCSSAction(targetAction);
      });

      next(action);

      break;
    }
    case actionTypes.UPDATE_ATOMIC_CSS: {
      const { options } = action.payload;
      const { strategy } = options;

      const newHTML = handleUpdateAtomicCSSAction(action);

      if (strategy !== UPDATE_LIVE_ONLY) {
        const state = store.getState();
        const pageId = site.selectors.getActivePageId(state);

        store.dispatch(site.actions.setPageHTML(pageId, newHTML));
      }

      next(action);

      break;
    }
    default:
      next(action);
  }
};

export default updateAtomicCSS;
